"use client";

import { useTranslations } from "next-intl";
import { DebugTableRows } from "../components/debug-primitives";
import type {
  DebugSessionContext,
  SafeDebugOrganization,
  SafeDebugUser,
} from "../debug-panel.types";

interface SessionContextPanelProps {
  user: SafeDebugUser | null;
  selectedOrganization: SafeDebugOrganization | null;
  sessionContext: DebugSessionContext;
}

export function SessionContextPanel({
  user,
  selectedOrganization,
  sessionContext,
}: SessionContextPanelProps) {
  const t = useTranslations("debug.session");

  return (
    <DebugTableRows
      rows={[
        { label: t("scope"), value: sessionContext.label },
        {
          label: t("navigationProjection"),
          value:
            user?.contextKind === "WORKSPACE"
              ? t("itemCount", {
                  count: user.effectiveNavigationItemIds?.length ?? 0,
                })
              : t("notApplicable"),
        },
        { label: t("state"), value: t(`states.${sessionContext.state}`) },
        {
          label: t("organizationType"),
          value: selectedOrganization?.type || t("unavailable"),
        },
        { label: t("transportContract"), value: t("opaqueServerSession") },
      ]}
    />
  );
}
